import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: 'Имя отправителя',
  sender_wallet: 'Кошелёк отправителя',
  last_n_digits: 'Референс транзакции',
  invoice_flow__multi_time_remainin: 'Оставшееся время',
  invoice_flow__multi_or: 'ИЛИ',
  invoice_flow__multi_open_app: 'Открыть в приложении',
  invoice_flow__multi_return_button: 'Вернуться на веб-сайт',
  invoice_flow__card_transfer_button: 'Подтвердить',

  //Steps
  invoice_flow__multi_upi_qr_step_1: 'Отсканируйте или скопируйте QR-код',
  invoice_flow__multi_upi_qr_step_2: 'Совершите оплату',
  invoice_flow__multi_step_3:
    'Для подтверждения оплаты укажите <b>{attributes}</b> и нажмите кнопку "Подтвердить"',
  invoice_flow__multi_upi_qr_mob_step_1:
    'Отсканируйте QR-код или нажмите кнопку "Открыть в приложении"',

  invoice_flow__multi_bank_transfer_step_1: 'Скопируйте реквизиты',
  invoice_flow__multi_bank_transfer_step_2: 'Совершите оплату',

  invoice_flow__card_transfer_step_1: 'Скопируйте реквизиты',
  invoice_flow__card_transfer_step_2:
    'Переведите указанную сумму (используйте свой банкинг, терминал самообслуживания или обратитесь в ближайшее отделение банка)',
  invoice_flow__card_transfer_step_3: 'Укажите данные для потдверждения: <b>{attributes}</b>',
  invoice_flow__card_transfer_step_4:
    'После успешного завершения перевода - нажмите <b>"Подтвердить"</b>',
};
